import React, { useState } from "react";
import "./Tabs.scss";

const Tabs = ({ onTabChange, tabs = [] }) => {
    const [activeTab, setActiveTab] = useState(tabs[0] || "Semana");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        onTabChange(tab);
    };

    return (
        <div className="tabs-container">
            <div className="tabs">
                {tabs.includes("Semana") && (
                    <button
                        className={`tab ${activeTab === "Semana" ? "active" : ""}`}
                        onClick={() => handleTabClick("Semana")}
                    >
                        Semana
                    </button>
                )}
                {tabs.includes("Mes") && (
                    <button
                        className={`tab ${activeTab === "Mes" ? "active" : ""}`}
                        onClick={() => handleTabClick("Mes")}
                    >
                        Mes
                    </button>
                )}
                {tabs.includes("Año") && (
                    <button
                        className={`tab ${activeTab === "Año" ? "active" : ""}`}
                        onClick={() => handleTabClick("Año")}
                    >
                        Año
                    </button>
                )}
            </div>
        </div>
    );
};

export default Tabs;
